import React from 'react';
import ReactDOM from 'react-dom/client';
import AppWrapper from './AppWrapper';
import { HashRouter } from 'react-router-dom'
import * as serviceWorker from './serviceWorker';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'prismjs/themes/prism-coy.css';
import { Provider } from 'react-redux';
import store from './store/store';
import NotificationProvider from './components/NotificationProvider';
import { PrimeReactProvider } from 'primereact/api';

// Polyfill for findDOMNode removed in React 19 (needed for Material-UI v4 and react-transition-group)
// This is a temporary workaround until we upgrade to MUI v5
if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = (instance) => {
    if (instance == null) {
      return null;
    }
    if (instance.nodeType === 1) {
      return instance;
    }
    // For React components, try to get the underlying DOM node
    return instance._reactInternals?.stateNode || null;
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PrimeReactProvider>
    <Provider store={store}>
      <NotificationProvider>
        <HashRouter>
          <AppWrapper></AppWrapper>
        </HashRouter>
      </NotificationProvider>
    </Provider>
  </PrimeReactProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
